define('editor/edit/map/controls/scalebar',['leaflet-scalebar'], function () {
  var control = function (options) {
    var self = this;

    self.options = options;
    self.layer = options.layer;

    self.addToMap = function () {
      self.control = L.scalebar2({
        viewport: {
          height: self.options.editorMap.height,
          width: self.options.editorMap.width
        }
      });

      if (self.layer.visible()) {
        self.show();
      }

      self.registerEventHandlers();
    };

    self.registerEventHandlers = function () {
      self.options.mapControl.on('resize', self._onMapResize);
    };

    self.deregisterEventHandlers = function () {
      self.options.mapControl.off('resize', self._onMapResize);
    };

    self.setYOffset = function (newValue) {
      self.options.yOffset = newValue;
    };

    self.updatePosition = function () {
      self.control._setPosition(self.options.yOffset);
    };

    self._onMapResize = function () {
      self.updatePosition();
    };

    self.show = function () {
      self.control.addTo(self.options.mapControl);
      self.updatePosition();
      self.control._container.style.zIndex = 1000 - self.layer.order();
    };

    self.hide = function () {
      self.control.remove();
      self.deregisterEventHandlers();
    };

    self.remove = function () {
      self.hide();
      self.deregisterEventHandlers();
    };
  };

  return control;
});
